module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_blue.91316f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_blue.png
// module id = 2112
// module chunks = 0